var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFunction48Line = function SvgIconFunction48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm0 30c-7.33 0-13.3-5.97-13.3-13.3 0-7.33 5.97-13.3 13.3-13.3 7.33 0 13.3 5.97 13.3 13.3 0 7.33-5.97 13.3-13.3 13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34.2 24-2.4-2.4-2.8 2.79-2.8-2.79-2.4 2.4 2.8 2.8-2.8 2.8 2.4 2.4 2.8-2.8 2.8 2.8 2.4-2.4-2.8-2.8 2.8-2.8ZM18.7 19.6c0-1.05.85-1.9 1.9-1.9H24v-3.4h-3.4a5.31 5.31 0 0 0-5.3 5.3V32h3.4v-8.3H23v-3.4h-4.3v-.7Z",
    fill: "current"
  })));
};
export default SvgIconFunction48Line;